import React, { useRef, useState } from 'react';
import Header from '../Header';
import HeroSection from '../homepage/HeroSection';
import BusinessSection from '../homepage/BusinessSection';
import BusinesNeedsSection from '../homepage/BusinesNeedsSection';
import FormSection from '../homepage/FormSection';
import ChooseusSection from '../homepage/ChooseusSection';
import FaqSection from '../homepage/FaqSection';
import TestimonialSection from '../homepage/TestimonialSection';
import Footer from '../Footer';
import usePageTitle from '../../hooks/usePageTitle';

const HomePage = () => {
    usePageTitle('page-title', 'homepage');
    const formRef = useRef(null);
    const handleClick = () => {
        formRef.current?.scrollIntoView({behavior: 'smooth'});
    };

    // Form Section
    const [selectedValue, setSelectedValue] = useState("");
    const handleBoxClick = (value) => {
        setSelectedValue(value);
    };
    return (
        <>
            <Header />
            <HeroSection onScrollToForm={handleClick} />
            <BusinessSection />
            <BusinesNeedsSection onScrollToForm={handleClick} onBoxClick={handleBoxClick} />
            <FormSection ref={formRef} selectedValue={selectedValue} />
            <TestimonialSection />
            <ChooseusSection />
            <FaqSection />
            <Footer />
        </>
    );
}

export default HomePage;